import { render } from "./SpecialCategory.vue?vue&type=template&id=1132e186"
import script from "./SpecialCategory.vue?vue&type=script&lang=js"
export * from "./SpecialCategory.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__